import { render, staticRenderFns } from "./PropagandistModal.vue?vue&type=template&id=cf42599e&"
import script from "./PropagandistModal.vue?vue&type=script&lang=js&"
export * from "./PropagandistModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports